export const FORM_ID = 'orders.contact-customer'

export const INITIAL_VALUES = {
  message: '',
  orderLineId: '',
}
